// extracted by mini-css-extract-plugin
module.exports = {"tabContainer":"TradesListTabs_tabContainer__B8AF_","tablet":"TradesListTabs_tablet__a2fZ7","tabBtn":"TradesListTabs_tabBtn__WHo_O","active":"TradesListTabs_active__MgD0l"};